<template>
  <div class="header-child header-green">
    Subject Attendance
  </div>

  <div class="content-base">
  </div>
</template>
